// extracted by mini-css-extract-plugin
export default {"warningIcon":"sG6_9","border":"WcWqa","display":"j3cH4","stand":"TY0XK"};